import { graphql, useStaticQuery } from 'gatsby'

interface ThemeSettingsQueryType {
	wp: {
		themeSettings: {
			themeSettings: {
				companyLine: string
				serviceNumber: string
				salesNumber: string
				salesEmail: string
				generalNumber: string
				generalEmail: string
				pressNumber: string
				copyrightLine: string
				socialMedia: {
					facebook: string
					twitter: string
					youtube: string
					linkedin: string
					instagram: string
				}
			}
		}
	}
}

export const useThemeSettings = () => {
	const data = useStaticQuery<ThemeSettingsQueryType>(graphql`
		query ThemeSettingsData {
			wp {
				themeSettings {
					themeSettings {
						companyLine
						serviceNumber
						salesNumber
						salesEmail
						generalNumber
						generalEmail
						pressNumber
						copyrightLine
						socialMedia {
							facebook
							twitter
							youtube
							linkedin
							instagram
						}
					}
				}
			}
		}
	`)

	return data.wp.themeSettings.themeSettings
}
